import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import CategoryList from "./CategoryList";
import CategoryForm from "./CategoryForm";

import { ADD_NEW } from "constants/commonConstants";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import categoryReducer from "store/Masters/Category/reducer";
import categorySaga from "store/Masters/Category/saga";

const categoryKey = "CategoryMaster";

const withCategoryReducer = injectReducer({
  key: categoryKey,
  reducer: categoryReducer,
});
const withCategorySaga = injectSaga({ key: categoryKey, saga: categorySaga });

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      categoryData: null,
    };

    this.validator = new SimpleReactValidator();
  }

  onCategoryInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
      categoryData: null,
    });
  };

  viewCategory = (category) => {
    this.setState({
      formDialog: true,
      categoryData: category,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <CategoryForm
            formDialog={this.state.formDialog}
            categoryRecord={this.state.categoryData}
            closeModal={() => this.onCategoryInsertUpdateSuccess()}
          ></CategoryForm>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <h4 className="mt-0 page-title">Category</h4>
                    <button
                      className="btn btn-primary waves-effect waves-light float-right"
                      onClick={() => this.viewCategory(null)}
                    >
                      {ADD_NEW}
                    </button>
                  </div>

                  <CategoryList
                    onViewCategory={(categoryValues) =>
                      this.viewCategory(categoryValues)
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withCategoryReducer,
  withCategorySaga,
  withRouter
)(Index);
//export default withRouter(withConnect)(Index);
